import React from "react";
import MateriasView from "./pages/MateriasView";

export default function Materias() {
  return <MateriasView />;
}
